import { CSSProperties } from 'react';
import { Outlet } from 'react-router';
import { FooterComponent } from './footer.component';
import { HeaderComponent } from './header.component';
import { useLocation, useNavigate } from 'react-router';
import { usePortalConfigContext } from '@vivli/core/infrastructure/context';

const bodyStyle: CSSProperties = {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    zIndex: 1,
};

export const LayoutWrapper = () => {
    const navigate = useNavigate();
    const { getSearchLink } = usePortalConfigContext();
    const location = useLocation();

    // only show header/footer if we are not using the virtual machine route
    const showHeaderFooter = !location.pathname.includes('virtual-machine');

    const handleFindStudiesClick = () => {
        const link = getSearchLink();
        navigate(link);
    };

    const containerStyle: CSSProperties = {
        height: '100%',
        width: '100%',
        display: 'grid',
        gridTemplateRows: showHeaderFooter ? 'auto 1fr auto' : '1fr',
    };

    return (
        <div style={containerStyle}>
            {showHeaderFooter && <HeaderComponent onFindStudiesClick={handleFindStudiesClick} />}
            <div style={bodyStyle}>
                <Outlet />
            </div>
            {showHeaderFooter && <FooterComponent />}
        </div>
    );
};
